var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasItems) ? _c('ul', {
    staticClass: "list uk-list",
    class: _vm.listCss
  }, _vm._l((_vm.items), function(item) {
    return _c('li', [_vm._t("item", [_vm._v(_vm._s(item))], {
      item: item
    })], 2)
  })) : _c('div', [_vm._t("empty")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c731d9ce","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/List.vue
// module id = 2105
// module chunks = 0